import classnames from 'classnames';
import type { LinkProps, NavLinkProps } from 'react-router-dom';
import { Link, NavLink } from 'react-router-dom';
import type { HTMLAttributes, AnchorHTMLAttributes } from 'react';

import style from './style.scss';

const PageTitle = ({ className, children, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  const textClassName = classnames(style.pageTitle, className);
  return (
    <h2 className={textClassName} {...props}>
      {children}
    </h2>
  );
};

const PageSubtitle = ({ className, children, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  const textClassName = classnames(style.pageSubtitle, className);
  return (
    <h3 className={textClassName} {...props}>
      {children}
    </h3>
  );
};

const EmptyTitle = ({ className, children, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  const textClassName = classnames(style.emptyTitle, className);
  return (
    <h3 className={textClassName} {...props}>
      {children}
    </h3>
  );
};

const Title = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  const textClassName = classnames(style.title, className);
  return <div className={textClassName} {...props} />;
};

const Indicator = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement> & { htmlFor?: string }) => {
  const textClassName = classnames(style.indicator, className);
  return <div className={textClassName} {...props} />;
};

const UppercaseLight = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  const textClassName = classnames(style.uppercaseLight, className);
  return <div className={textClassName} {...props} />;
};

const InputLabel = ({ className, children, ...props }: HTMLAttributes<HTMLLabelElement>) => {
  const textClassName = classnames(style.inputLabel, className);
  return (
    <label className={textClassName} {...props}>
      {children}
    </label>
  );
};

const TextAnchor = ({ className, children, ...props }: AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const linkClassName = classnames(style.linkText, className);
  return (
    <a className={linkClassName} {...props}>
      {children}
    </a>
  );
};

const TextLink = ({ className, ...props }: LinkProps) => {
  const linkClassName = classnames(style.linkText, className);
  return <Link className={linkClassName} {...props} />;
};

const MenuLink = ({
  className,
  activeClassName,
  ...props
}: NavLinkProps & { activeClassName?: string; className?: string }) => {
  const linkClassName = classnames(style.navLink, className);
  const linkActiveClassName = classnames(style.navLink_active, activeClassName);
  return (
    <NavLink
      className={({ isActive }) => classnames(linkClassName, { [linkActiveClassName]: isActive })}
      {...props}
    />
  );
};

const Paragraph = ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) => {
  const textClassName = classnames(style.paragraph, className);
  return <p className={textClassName} {...props} />;
};

export {
  PageTitle,
  PageSubtitle,
  EmptyTitle,
  Title,
  Indicator,
  UppercaseLight,
  InputLabel,
  TextAnchor,
  TextLink,
  MenuLink,
  Paragraph
};
